(() => {
  const odometers = document.querySelectorAll('[id*="odometer"]');

  function elementInViewport (el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  }

  function setOdometer ({ id, value }) {
    const element = document.querySelector('#' + id);
    element.classList.add('odometer-theme-minimal');

    triggerOdometer(element, value);
  }

  function triggerOdometer (element, value) {
    const odometerValue = element.querySelector('.odometer-value');
    let currentValue;

    if (odometerValue) currentValue = odometerValue.innerText;

    if (elementInViewport(element) && currentValue !== value) {
      setTimeout(() => {
        element.innerHTML = value;
      }, 0);
    }
  }

  if (odometers.length > 0) {
    for (let i = 0; i < odometers.length; i++) {
      const { id } = odometers[i];
      const value = odometers[i].getAttribute('data-number');
      const element = document.querySelector('#' + id);

      if (value) {
        setOdometer({
          element,
          id,
          value,
        });
      }

      window.addEventListener('scroll', () => {
        triggerOdometer(element, value);
      });
    }
  }
})();
